<template>
  <div class="introduction">
    <div class="col-12 row">
      <div class="introTitle">
        <h2 v-html="introduction.headlineText" class="headline"></h2>
        <div
          v-if="introduction.headlineSubheaderText && !showHeadlineOnly"
          v-html="introduction.headlineSubheaderText"
          class="subHeaderText"
        ></div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Introduction",
  props: {
    introduction: Object,
    showHeadlineOnly: Boolean,
  },
  computed: {
    hasProgramLink() {
      return this.introduction.programSummaryButtonLink && this.introduction.programSummaryButtonLabel;
    },
  },
};
</script>
<style lang="scss">
.row {
  .introTitle {
    padding: 50px 40px;
    .subHeaderText {
      font-size: 24px;
      line-height: 150%;
      margin: 30px 0 0 0;
      color: var(--primaryText);

      p {
        font-size: 24px;
        line-height: 150%;
        margin: 0;
      }
    }

    .headline {
      font-size: 50px;
      line-height: 120%;
      font-weight: 400;
      color: var(--secondaryText);
      margin: 0;

      p {
        color: inherit;
        font-size: inherit;
        line-height: inherit;
        margin: 0;
      }

      ol,
      ul {
        padding-left: 3rem;
      }
    }
  }
}

.introduction {
  font-family: var(--micrositeTypeStyle);
  .button {
    @include round-btn();
    display: inline-block;
    margin-top: 10px;
  }
}

.introduction p,
.introduction h2 {
  font-weight: 400;
}

.headerContent {
  h3 {
    margin: 0 0 20px 0;
  }
  .content-holder {
    margin-bottom: 30px;
  }
  .content {
    font-size: 15px;
    line-height: 150%;
    color: var(--primaryText);
  }
}

.introduction .headerContent {
  background-color: var(--backgroundAccent);
  padding: 40px;
}

@include media-breakpoint-down(md) {
  .introduction .introTitle,
  .headerContent {
    padding: 30px !important;
  }
}
</style>
